import { apiRequest } from '../Api';

export type LoginMethod = 'MANUAL' | 'SSO';

export interface LoginRequest {
  /**
   * Identifier used for login (e.g. email or username).
   */
  identity_key: string;
  /**
   * Secret used for authentication (e.g. password or SSO token).
   */
  auth_secret: string;
  /**
   * Login method used for this request.
   */
  method: LoginMethod;
}

export interface User {
  id: string;
  name: string | null;
  email: string;
}

export interface Brand {
  name: string;
  slug: string;
  id: string;
}

export interface LoginResponse {
  success: boolean;
  data?: {
    access_token: string;
    token_expires_at: string;
    user: User;
    brands: Brand[];
    role: string | null;
    session_log_id: string;
    session_token: string;
  };
  message?: string;
  execution_time?: number;
  timestamp?: string;
}

export async function login(data: LoginRequest) {
  const response = await apiRequest<LoginRequest, LoginResponse>({
    url: '/auth/login',
    method: 'POST',
    data,
    backend: 'landing',
    excludeAuthentication: true,
    params: undefined,
  });

  return response.data;
}
